'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var LoginLayout = require('../components/Layout/LoginLayout.js');
require('../components/PopUp.scss.js');
require('./Forms.scss.js');
var LoginAccountForm = require('./LoginAccountForm.js');
var OTPForm = require('./OTPForm.js');
var LoginForm = require('./LoginForm.js');
var RegisterForm = require('./RegisterForm.js');
var handlePhoneNumber = require('../../../utils/handlePhoneNumber.js');
var constant = require('./constant.js');
var KYCForm = require('./KYCForm.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var CompleteLoginForm = function (props) {
    var onSubmit = props.onSubmit; props.back; var onOTPChange = props.onOTPChange, onVerificationButtonClick = props.onVerificationButtonClick; props.onBackButtonClick; var onSendOtp = props.onSendOtp, current = props.current; props.phoneNumber; var thisError = props.errorMessage; props.onPhoneNumberChange; props.onMailButtonClick; props.onNextButtonClick; var onRegisterClick = props.onRegisterClick, onRegisterSubmit = props.onRegisterSubmit, onSubmitKYC = props.onSubmitKYC, kyc = props.kyc; props.onValueChange; var others = tslib_es6.__rest(props, ["onSubmit", "back", "onOTPChange", "onVerificationButtonClick", "onBackButtonClick", "onSendOtp", "current", "phoneNumber", "errorMessage", "onPhoneNumberChange", "onMailButtonClick", "onNextButtonClick", "onRegisterClick", "onRegisterSubmit", "onSubmitKYC", "kyc", "onValueChange"]);
    var _a = React.useState(current || 'login'), page = _a[0], setPage = _a[1];
    var _b = React.useState(''), phoneNumber = _b[0], setPhoneNumber = _b[1];
    var _c = React.useState({}), errorMessage = _c[0], setErrorMessage = _c[1];
    var handlePageChange = function (thisPage) {
        setErrorMessage({});
        if (thisPage !== 'otp') {
            setPhoneNumber('');
        }
        setPage(thisPage);
    };
    var Form = function () {
        switch (page) {
            case 'login':
                return React__default['default'].createElement(LoginAccountForm.LoginAccountForm, tslib_es6.__assign({ errorMessage: errorMessage, onMailButtonClick: function () { handlePageChange('email'); }, onPhoneNumberChange: function (phone) {
                        setErrorMessage({});
                        setPhoneNumber(handlePhoneNumber.handlePhoneNumber(phone.split(' ').join('')).idn.split(' ').join(''));
                    }, onNextButtonClick: function () { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
                        return tslib_es6.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(handlePhoneNumber.idnPhoneValidation(phoneNumber.slice(3)) && onSendOtp)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, onSendOtp(phoneNumber)];
                                case 1:
                                    _a.sent();
                                    handlePageChange('otp');
                                    return [3 /*break*/, 3];
                                case 2:
                                    setErrorMessage(tslib_es6.__assign(tslib_es6.__assign({}, errorMessage), { phoneNumber: !phoneNumber ? constant.errorMessages.phoneNumber : constant.errorMessages.invalidPhoneNumber }));
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, onRegisterClick: function () {
                        if (onRegisterClick) {
                            onRegisterClick();
                        }
                        else {
                            handlePageChange('register');
                        }
                    } }, others));
            case 'otp':
                return React__default['default'].createElement(OTPForm.OTPForm, tslib_es6.__assign({ errorMessage: errorMessage, onOTPChange: function (otp) {
                        setErrorMessage({});
                        if (onOTPChange) {
                            onOTPChange(otp);
                        }
                    }, onVerificationButtonClick: function (otp) {
                        if (otp.split('').length === 6) {
                            onVerificationButtonClick(otp);
                        }
                        else {
                            setErrorMessage(tslib_es6.__assign(tslib_es6.__assign({}, errorMessage), { otp: constant.errorMessages.otp }));
                        }
                    }, back: true, onBackButtonClick: function () { handlePageChange('login'); }, phoneNumber: phoneNumber }, others));
            case 'register':
                return React__default['default'].createElement(RegisterForm.RegisterForm, tslib_es6.__assign({ onRegisterSubmit: function (payload) {
                        var errors = Object.keys(payload).filter(function (key) { return payload[key] === ''; });
                        if (errors.length > 0 || (thisError && Object.keys(thisError).length > 0)) {
                            errors.forEach(function (thisKey) {
                                errorMessage[thisKey] = constant.errorMessages[thisKey];
                            });
                        }
                        if (payload.phoneNumber && !handlePhoneNumber.idnPhoneValidation(payload.phoneNumber.toString())) {
                            errorMessage.phoneNumber = constant.errorMessages.invalidPhoneNumber;
                        }
                        else {
                            payload.phoneNumber = handlePhoneNumber.handlePhoneNumber(payload.phoneNumber.toString()).idn.split(' ').join('');
                        }
                        if (payload.password !== payload.confirmPassword) {
                            errorMessage.confirmPassword = constant.errorMessages.confirmPassword;
                        }
                        if (Object.keys(errorMessage).length === 0) {
                            onRegisterSubmit(payload);
                        }
                        else {
                            setErrorMessage(tslib_es6.__assign(tslib_es6.__assign({}, errorMessage), thisError));
                        }
                    }, onValueChange: function () {
                        setErrorMessage({});
                    }, errorMessage: errorMessage, back: true, onBackButtonClick: function () { handlePageChange('login'); } }, others));
            default:
                return (React__default['default'].createElement(LoginForm.LoginForm, tslib_es6.__assign({ singleError: true, onSubmit: function (payload) {
                        if (!payload.email) {
                            errorMessage.email = constant.errorMessages.email;
                        }
                        else {
                            delete errorMessage.email;
                        }
                        if (!payload.password) {
                            errorMessage.password = constant.errorMessages.password;
                        }
                        else {
                            delete errorMessage.password;
                        }
                        if (errorMessage.email || errorMessage.password) {
                            setErrorMessage(tslib_es6.__assign(tslib_es6.__assign({}, errorMessage), thisError));
                        }
                        else {
                            onSubmit(payload);
                        }
                    }, onValueChange: function () {
                        setErrorMessage({});
                    }, onRegisterClick: function () {
                        if (onRegisterClick) {
                            onRegisterClick();
                        }
                        else {
                            handlePageChange('register');
                        }
                    }, back: true, onBackButtonClick: function () { handlePageChange('login'); }, errorMessage: errorMessage }, others)));
        }
    };
    return (React__default['default'].createElement(LoginLayout.LoginLayout, null, !kyc ? Form() : React__default['default'].createElement(KYCForm.KYCForm, tslib_es6.__assign({ errorMessage: errorMessage, onSubmit: function (payload) {
            if (onSubmitKYC) {
                if (!payload.type) {
                    errorMessage.type = constant.errorMessages.type;
                }
                else {
                    delete errorMessage.type;
                }
                if (payload.type === 'KTP' && !payload.ktp) {
                    delete errorMessage.passport;
                    errorMessage.ktp = constant.errorMessages.ktp;
                }
                else if (payload.type === 'Passport' && !payload.passport) {
                    delete errorMessage.ktp;
                    errorMessage.passport = constant.errorMessages.passport;
                }
                else {
                    if (payload.type === 'KTP') {
                        if (payload.ktp.length !== 16) {
                            errorMessage.ktp = constant.errorMessages.maxCardNumber;
                        }
                        else {
                            delete errorMessage.ktp;
                        }
                    }
                    else {
                        if (payload.passport.length !== 16) {
                            errorMessage.passport = constant.errorMessages.maxCardNumber;
                        }
                        else {
                            delete errorMessage.passport;
                        }
                    }
                }
                if (!payload.annualIncome) {
                    errorMessage.annualIncome = constant.errorMessages.annualIncome;
                }
                else {
                    delete errorMessage.annualIncome;
                }
                if (!payload.sourceOfFund) {
                    errorMessage.sourceOfFund = constant.errorMessages.sourceOfFund;
                }
                else {
                    delete errorMessage.sourceOfFund;
                }
                if (Object.keys(errorMessage).length === 0) {
                    onSubmitKYC(payload);
                    handlePageChange('login');
                }
                else {
                    setErrorMessage(tslib_es6.__assign(tslib_es6.__assign({}, errorMessage), thisError));
                }
            }
        }, onValueChange: function () { setErrorMessage({}); } }, others))));
};

exports.CompleteLoginForm = CompleteLoginForm;
//# sourceMappingURL=CompleteLoginForm.js.map
